export const URG = {
  critical:   { label: 'Critical',   color: '#FF4545', bg: 'rgba(255,69,69,0.13)'   },
  stable:     { label: 'Stable',     color: '#64D2FF', bg: 'rgba(100,210,255,0.11)' },
  new:        { label: 'New',        color: '#FF9500', bg: 'rgba(255,149,0,0.13)'   },
  mgh:        { label: 'MGH',        color: '#BF5AF2', bg: 'rgba(191,90,242,0.13)'  },
  discharged: { label: 'Discharged', color: '#30D158', bg: 'rgba(48,209,88,0.11)'   },
  mortality:  { label: 'Mortality',  color: '#8E8E93', bg: 'rgba(142,142,147,0.13)' },
};

export const UORD = { critical: 0, new: 1, mgh: 2, stable: 3, discharged: 4, mortality: 5 };

export const CCOL = {
  'Primary':  '#4A9EFF',
  'Referral': '#BF5AF2',
};

export const CLIST = ['Primary', 'Referral'];

export const VF = [
  { k: 'vBP', lb: 'BP',   unit: 'mmHg', ph: '120/80' },
  { k: 'vHR', lb: 'HR',   unit: 'bpm',  ph: '72'     },
  { k: 'vRR', lb: 'RR',   unit: '/min', ph: '16'      },
  { k: 'vT',  lb: 'Temp', unit: '°C',   ph: '37.0'   },
  { k: 'vO2', lb: 'SpO2', unit: '%',    ph: '98'      },
  { k: 'vAVPU', lb: 'AVPU', unit: '', ph: '' },
  { k: 'vGCS',  lb: 'GCS',  unit: '', ph: '' },
];

// ── RESUS STATUS ─────────────────────────────────────────────
export const RESUS_OPTIONS = [
  { k: 'full',     label: 'Full Resus',   short: 'FULL',  color: '#30D158', bg: 'rgba(48,209,88,0.13)'  },
  { k: 'limited',  label: 'Limited',      short: 'LIM',   color: '#FF9500', bg: 'rgba(255,149,0,0.13)'  },
  { k: 'dnr',      label: 'DNR / DNAR',   short: 'DNR',   color: '#FF4545', bg: 'rgba(255,69,69,0.13)'  },
  { k: 'comfort',  label: 'Comfort Care', short: 'CMF',   color: '#BF5AF2', bg: 'rgba(191,90,242,0.13)' },
];

// ── NEWS2 SCORING ─────────────────────────────────────────────
export const calcNEWS2 = (v) => {
  if (!v) return null;
  let score = 0;
  const reasons = [];

  // Respiratory Rate
  const rr = parseFloat(v.vRR);
  if (!isNaN(rr)) {
    if      (rr <= 8)  { score += 3; reasons.push('RR ' + rr + ' (/min) +3'); }
    else if (rr <= 11) { score += 1; reasons.push('RR ' + rr + ' (/min) +1'); }
    else if (rr <= 20) { /* 0 */ }
    else if (rr <= 24) { score += 2; reasons.push('RR ' + rr + ' (/min) +2'); }
    else               { score += 3; reasons.push('RR ' + rr + ' (/min) +3'); }
  }

  // SpO2 (Scale 1 — standard)
  const spo2 = parseFloat(v.vO2);
  if (!isNaN(spo2)) {
    if      (spo2 <= 91) { score += 3; reasons.push('SpO2 ' + spo2 + '% +3'); }
    else if (spo2 <= 93) { score += 2; reasons.push('SpO2 ' + spo2 + '% +2'); }
    else if (spo2 <= 95) { score += 1; reasons.push('SpO2 ' + spo2 + '% +1'); }
  }

  // Systolic BP (from vBP e.g. "120/80")
  const bpStr = (v.vBP || '').split('/')[0];
  const sbp = parseFloat(bpStr);
  if (!isNaN(sbp)) {
    if      (sbp <= 90)  { score += 3; reasons.push('SBP ' + sbp + ' mmHg +3'); }
    else if (sbp <= 100) { score += 2; reasons.push('SBP ' + sbp + ' mmHg +2'); }
    else if (sbp <= 110) { score += 1; reasons.push('SBP ' + sbp + ' mmHg +1'); }
    else if (sbp <= 219) { /* 0 */ }
    else                 { score += 3; reasons.push('SBP ' + sbp + ' mmHg +3'); }
  }

  // Heart Rate
  const hr = parseFloat(v.vHR);
  if (!isNaN(hr)) {
    if      (hr <= 40)  { score += 3; reasons.push('HR ' + hr + ' bpm +3'); }
    else if (hr <= 50)  { score += 1; reasons.push('HR ' + hr + ' bpm +1'); }
    else if (hr <= 90)  { /* 0 */ }
    else if (hr <= 110) { score += 1; reasons.push('HR ' + hr + ' bpm +1'); }
    else if (hr <= 130) { score += 2; reasons.push('HR ' + hr + ' bpm +2'); }
    else                { score += 3; reasons.push('HR ' + hr + ' bpm +3'); }
  }

  // Temperature
  const temp = parseFloat(v.vT);
  if (!isNaN(temp)) {
    if      (temp <= 35.0) { score += 3; reasons.push('Temp ' + temp + ' +3'); }
    else if (temp <= 36.0) { score += 1; reasons.push('Temp ' + temp + ' +1'); }
    else if (temp <= 38.0) { /* 0 */ }
    else if (temp <= 39.0) { score += 1; reasons.push('Temp ' + temp + ' +1'); }
    else                   { score += 2; reasons.push('Temp ' + temp + ' +2'); }
  }

  // AVPU
  if (v.vAVPU && v.vAVPU !== 'A') {
    score += 3; reasons.push('AVPU: ' + v.vAVPU + ' +3');
  }

  // Colour coding
  let color, bg, risk;
  if      (score === 0)            { color = '#30D158'; bg = 'rgba(48,209,88,0.15)';    risk = 'Low'; }
  else if (score <= 4)             { color = '#FFD60A'; bg = 'rgba(255,214,10,0.15)';   risk = 'Low-Med'; }
  else if (score <= 6)             { color = '#FF9500'; bg = 'rgba(255,149,0,0.15)';    risk = 'Medium'; }
  else                             { color = '#FF4545'; bg = 'rgba(255,69,69,0.15)';    risk = 'HIGH'; }

  // Any single param scoring 3 = at least medium
  const hasRed3 = reasons.some(r => r.endsWith('+3'));
  if (hasRed3 && score >= 3 && score <= 4) {
    color = '#FF9500'; bg = 'rgba(255,149,0,0.15)'; risk = 'Medium';
  }

  return { score, color, bg, risk, reasons };
};

export const LABS = [
  'WBC','Hgb','Plt','Na','K','Cr','BUN','Glucose',
  'ALT','AST','INR','aPTT','Lactate','CRP','Troponin','BNP','Mg','Phos','Ca','Alb',
];

export const DTMS = [
  { id: 'ta', name: 'Team A', color: '#4A9EFF', icon: 'A' },
  { id: 'tb', name: 'Team B', color: '#FF9500', icon: 'B' },
  { id: 'tc', name: 'Team C', color: '#FF4545', icon: 'C' },
];

export const TCOLS = [
  '#4A9EFF','#FF9500','#FF4545','#BF5AF2',
  '#30D158','#FF6B9D','#64D2FF','#FFD60A',
];

export const C = {
  bg0: '#050E18', bg1: '#0B1525', bg2: '#111C2A', bg3: '#0D1A28',
  bd: '#1C2E42', tx: '#C8DFF0', dim: '#5A7A94', dim2: '#3A5A74',
};

export const GCS = `
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&family=IBM+Plex+Sans:wght@400;500;600;700;800&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
html, body, #root { height: 100%; }
body { font-family: 'IBM Plex Sans', sans-serif; background: #050E18; -webkit-font-smoothing: antialiased; }
input, textarea, select, button { font-family: 'IBM Plex Sans', sans-serif; }
button { touch-action: manipulation; -webkit-backface-visibility: hidden; backface-visibility: hidden; }
textarea { resize: vertical; }
::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #1C2E42; border-radius: 2px; }

/* ── Safe area vars ── */
:root {
  --sat: env(safe-area-inset-top,    0px);
  --sab: env(safe-area-inset-bottom, 0px);
  --sal: env(safe-area-inset-left,   0px);
  --sar: env(safe-area-inset-right,  0px);
}

/* TopBar: clears notch/Dynamic Island/punch-hole top */
.topbar {
  padding-top:    max(14px, var(--sat));
  padding-bottom: 14px;
  padding-left:   max(16px, var(--sal));
  padding-right:  max(16px, var(--sar));
}

/* Desktop topbar: respect iPad/notch safe area, match mobile on regular screens */
@media (min-width: 900px) {
  .topbar {
    padding-top:    max(14px, env(safe-area-inset-top, 14px));
    padding-bottom: 14px;
    font-size: 16px;
  }
}

/* Bottom chrome: clears home indicator / Android nav bar */
.bottom-bar {
  padding-top:    10px;
  padding-bottom: max(10px, var(--sab));
  padding-left:   max(14px, var(--sal));
  padding-right:  max(14px, var(--sar));
}

/* Scroll containers: side padding in landscape (notch on sides) */
.scroll-safe {
  padding-left:  max(0px, var(--sal));
  padding-right: max(0px, var(--sar));
}

/* Filter rows that scroll horizontally: prevent clipping under side notch */
.hscroll-safe {
  padding-left:  max(14px, calc(var(--sal) + 8px));
  padding-right: max(14px, calc(var(--sar) + 8px));
  scroll-padding-left: max(14px, calc(var(--sal) + 8px));
}

/* Tablet/desktop: center narrow content with comfortable margins */
@media (min-width: 600px) {
  .mobile-shell {
    max-width: 520px !important;
  }
}

/* Small phones (SE, Fold closed ~344px) */
@media (max-width: 375px) {
  .tally-grid { gap: 3px !important; }
  .tally-label { display: none !important; }
}

/* Landscape on phones */
@media (orientation: landscape) and (max-height: 500px) {
  .topbar {
    padding-top:    max(8px, var(--sat));
    padding-bottom: 8px;
  }
  .bottom-bar {
    padding-top:    6px;
    padding-bottom: max(6px, var(--sab));
  }
}

/* Foldable: when unfolded to tablet width, allow wider layout */
@media (min-width: 600px) and (max-width: 900px) {
  .mobile-shell { max-width: 600px !important; }
}
`;

// ── TASK PRIORITY ─────────────────────────────────────────────
export const TASK_PRIORITY = [
  { k: 'urgent',  label: 'Urgent',  color: '#FF4545', bg: 'rgba(255,69,69,0.15)'   },
  { k: 'soon',    label: 'Soon',    color: '#FF9500', bg: 'rgba(255,149,0,0.15)'   },
  { k: 'routine', label: 'Routine', color: '#5A7A94', bg: 'rgba(90,122,148,0.15)'  },
];

// ── VITALS NORMAL RANGES ──────────────────────────────────────
// Returns { color, bg } for a given field + value
export const vitalColor = (field, rawVal) => {
  if (!rawVal) return null;
  const RED   = { color: '#FF4545', bg: 'rgba(255,69,69,0.18)'   };
  const AMB   = { color: '#FF9500', bg: 'rgba(255,149,0,0.18)'   };
  const OK    = null;

  if (field === 'vHR') {
    const v = parseFloat(rawVal);
    if (isNaN(v)) return null;
    if (v < 40 || v > 130) return RED;
    if (v < 50 || v > 100) return AMB;
    return OK;
  }
  if (field === 'vRR') {
    const v = parseFloat(rawVal);
    if (isNaN(v)) return null;
    if (v <= 8 || v > 25) return RED;
    if (v > 20) return AMB;
    return OK;
  }
  if (field === 'vT') {
    const v = parseFloat(rawVal);
    if (isNaN(v)) return null;
    if (v <= 35.0 || v > 39.0) return RED;
    if (v < 36.0 || v > 38.0) return AMB;
    return OK;
  }
  if (field === 'vO2') {
    const v = parseFloat(rawVal);
    if (isNaN(v)) return null;
    if (v <= 91) return RED;
    if (v <= 94) return AMB;
    return OK;
  }
  if (field === 'vBP') {
    const parts = rawVal.split('/');
    const sbp = parseFloat(parts[0]);
    if (isNaN(sbp)) return null;
    if (sbp <= 90 || sbp > 180) return RED;
    if (sbp <= 100 || sbp > 140) return AMB;
    return OK;
  }
  return null;
};

// ── REVIEW STALE THRESHOLDS (ms) ─────────────────────────────
export const STALE_CRITICAL = 4 * 60 * 60 * 1000;   // 4h
export const STALE_DEFAULT  = 8 * 60 * 60 * 1000;   // 8h

// ── DEFAULT SUBSPECIALTIES ────────────────────────────────────
export const DSUBSPECS = [
  { id: 'cardio',  name: 'Cardio',  color: '#FF6B9D' },
  { id: 'pulmo',   name: 'Pulmo',   color: '#64D2FF' },
  { id: 'gi',      name: 'GI',      color: '#FF9500' },
  { id: 'neuro',   name: 'Neuro',   color: '#BF5AF2' },
  { id: 'nephro',  name: 'Nephro',  color: '#30D158' },
  { id: 'id',      name: 'ID',      color: '#FFD60A' },
];

export const SSCOLS = [
  '#FF6B9D','#64D2FF','#FF9500','#BF5AF2',
  '#30D158','#FFD60A','#4A9EFF','#FF4545',
];
